export const endPoints = {
  CREATE_SIP: "v1/robot-call/channel",
  ROBOTO_SIP: "v1/robot-call/channel/all",
  CAMPAGING_ALL: "v1/robot-call/campaign/filter",
  ONE_CAMPAGING: "v1/robot-call/campaign",
  CHANNEL_SHORT: "v1/robot-call/channel/all/short",
  CREATE_ROBOTO_DEBT: "v1/robot-call/campaign/debt",
}